"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamblingDueDiligenceKeyCriteriaItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const DueDiligenceCriteria_1 = require("../../enm/DueDiligenceCriteria");
exports.GamblingDueDiligenceKeyCriteriaItem = {
    priority: 1,
    label: 'fields.enm.due_diligence_criteria.label',
    fallbackLabel: 'Please check all key criteria that apply to select and evaluate merchants in this sector on the top of the regular Due Diligence (KYC) review:',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_gambling_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: DueDiligenceCriteria_1.DueDiligenceCriteriaRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_gambling_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
